<template>
  <div id="PostOfficeTransferCollection">
    <section class="header-area">
      <div class="title">委託郵局媒體轉帳代收總數表</div>
    </section>

    <section class="info-area">
      <div class="commission-info-1">
        <div>委託機構代號：B60</div>

        <div>區處代號：</div>
      </div>

      <table cellspacing="0">
        <tr>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">轉帳日期</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">總件數</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">總金額</td>
        </tr>

        <tr>
          <td align="center">{{ data.date }}</td>
          <td align="center">{{ data.count }}</td>
          <td align="center">{{ data.sum }}</td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <div class="commission-info-2">
        <div>委託機構名稱：永豐網路平台股份有限公司</div>

        <div>委託機構地址：台中市西屯區文心路三段238號4樓</div>
      </div>
    </section>

    <section class="info-area">
      <div class="commission-info-3">
        <div class="left">
          <div>聯絡電話：04-23149111</div>

          <div>傳真號碼：04-23145599</div>

          <div>經辦：</div>

          <div>主管：</div>
        </div>

        <div class="right">
          <div>委託機構蓋章處：</div>

          <div class="stamping-office"></div>
        </div>
      </div>
    </section>

    <section class="info-area">
      <div class="commission-info-4">
        <div>接收單位：中華郵政股份有限公司儲匯處劃撥管理科委辦帳務股</div>

        <div>地址：106-03 台北市愛國東路216號520室</div>

        <div class="phone">
          <div>電話號碼：</div>

          <div>
            <div>(02) 2391-4024</div>
            <div>(02) 2393-1261 分機 3396、3397、3560</div>
          </div>
        </div>

         <div class="fax">
          <div>傳真號碼：</div>

          <div>
            <div>(02) 2321-7770</div>
            <div>(02) 2356-0964</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PaymentSchedule',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  watch: {
    'data.id': {
      handler(newValue, oldValue) {

      },
      immediate: false
    }
  },
  data () {
    return {
    }
  },
  computed: {

  },
  mounted() {
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {

    },
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: DFKai-sb;
}

#PostOfficeTransferCollection {
  width: 560px;
  height: 794px;
  .header-area {
    margin-bottom: 30px;
    text-align: center;
    .title {
      font-size: 26px;
      font-weight: bold;
    }
  }
  .info-area {
    font-size: 18px;
    &:not(:last-child) {
      margin-bottom: 30px;
    }
    .commission-info-1 {
      display: flex;
      margin-bottom: 10px;
      column-gap: 120px;
    }
    table {
      width: 100%;
      table-layout: fixed;
      word-wrap: break-word;
      word-break: normal;
      font-size: 16px;
      line-height: 1;
      border: 1px solid #000000;
      tr {
        height: 30px;
        td {
          border: 1px solid #000000;
          &.text-weight-bold {
            font-weight: bold;
          }
          .sign {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            row-gap: 60px;
            padding: 30px;
          }
        }
      }
    }
    .commission-info-2 {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
    }
    .commission-info-3 {
      display: flex;
      align-items: center;
      column-gap: 140px;
      .left {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
      }
      .right {
        text-align: center;
        .stamping-office {
          width: 165px;
          height: 165px;
          border: 1px black dashed;
        }
      }
    }
    .commission-info-4 {
      .phone,
      .fax {
        display: flex;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/PrintTemplate/PostOfficeTransferCollection.vue